import { FormikHelpers } from "formik";
import { useGetEstablishment } from "./api/getEstablishment";
import { useEditEstablishment } from "./api/editEstablishment";
import EditEstablishmentForm from "./EditEstablishmentForm";
import { useEffect, useState } from "react";
import SelectInterface from "./SelectInterface";
import FallsUnder from "../FallsUnder/FallsUnder";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditEstablishment = ({handleCloseModal, establishmentId}: EditEstablishmentProps)  => {
  const getEstablishmentQuery = useGetEstablishment({establishmentId: establishmentId})
  const editEstablishmentMutation = useEditEstablishment({data: {}, establishmentId});

  const [interfaceModalVisible, setInterfaceModalVisible] = useState(false);
  const [fallsUnderModalVisible, setFallsUnderModalVisible] = useState(false);
  const [selectedField , setSelectedField] = useState("");

  const handleInterfaceButtonClick = (fieldName : string) => {
      setInterfaceModalVisible(true); 
      setSelectedField(fieldName);
    };

  const handleCloseInterfaceModal = () => {
      setInterfaceModalVisible(false); 
  };

  const handleFallsUnderButtonClick = () => {
    setFallsUnderModalVisible(true); 
  };

  const handleCloseFallsUnderModal = () => {
    setFallsUnderModalVisible(false); 
  };

  const initialValues: IEditEstablishmentForm = {
    description: getEstablishmentQuery.data?.description ? getEstablishmentQuery.data?.description : "",
    placeID: getEstablishmentQuery.data?.placeID ? getEstablishmentQuery.data.placeID.toString() : "",
    modemID: getEstablishmentQuery.data?.modemID ? getEstablishmentQuery.data.modemID.toString() : "",
    modemPort: getEstablishmentQuery.data?.modemPort ? getEstablishmentQuery.data?.modemPort : "",
    unID: getEstablishmentQuery.data?.unID ? getEstablishmentQuery.data?.unID : "",
    sapCode: getEstablishmentQuery.data?.sapCode ? getEstablishmentQuery.data?.sapCode : "",
    isEmporiki: getEstablishmentQuery.data?.isEmporiki ? getEstablishmentQuery.data?.isEmporiki : false,
    isCiti: getEstablishmentQuery.data?.isCiti ? getEstablishmentQuery.data?.isCiti : false,
    comments: getEstablishmentQuery.data?.comments ? getEstablishmentQuery.data?.comments : "",
    deleted: getEstablishmentQuery.data?.deleted ? getEstablishmentQuery.data?.deleted : false,
    filepath: getEstablishmentQuery.data?.filepath ? getEstablishmentQuery.data?.filepath : "",
    hubType: getEstablishmentQuery.data?.hubType ? getEstablishmentQuery.data?.hubType : "",
    anetVoice: getEstablishmentQuery.data?.anetVoice ? getEstablishmentQuery.data?.anetVoice : "",
    fallsUnder: getEstablishmentQuery.data?.fallsUnder ? getEstablishmentQuery.data?.fallsUnder.toString() : "",
  };


  const handleSubmit = async (values: IEditEstablishmentForm, { setSubmitting }: FormikHelpers<IEditEstablishmentForm>): Promise<void> => {
    try {
      await editEstablishmentMutation.mutateAsync({
        data: values,
        establishmentId: establishmentId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getEstablishmentQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getEstablishmentQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Καταστήματος.</div>
    )
  }

  return (
    <>
      {!getEstablishmentQuery.isLoading && getEstablishmentQuery.data &&
        <EditEstablishmentForm initialValues={initialValues} onSubmit={handleSubmit} onInterfaceButtonClick={handleInterfaceButtonClick} onFallsUnderButtonClick={handleFallsUnderButtonClick} />
      }

      {interfaceModalVisible &&
        <SelectInterface handleCloseModal={handleCloseInterfaceModal} initialMode={"create"} currentEstablishmentID={establishmentId} selectedField={selectedField}/>
      }


      <FallsUnder  handleCloseModal={handleCloseFallsUnderModal} establishmentId={establishmentId} fallsUnderModalVisible={fallsUnderModalVisible} />
      
    </>
  )
}

interface EditEstablishmentProps {
  establishmentId: number;
  handleCloseModal: () => void;
}

export default EditEstablishment;